import React, { useEffect, useId, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorNotice, primaryButton } from 'components/Operator/OperatorUi';
import { SignInAgain, useSupportReturn } from './supportUi';

/**
 * YAC-2026-009 PR7b。サポートが終わった（401 support_access_ended）ときの画面。ログインの画面ではなく、ここから
 * 「運営の画面に戻る」（POST /v1/web/sessions/<sid>/support/return。Cookie だけで送れる）へ導く。
 * 認証ガード（PrivateRoute）の外に置く（サポートのトークンはもう更新できない）。
 * 戻れない（401 operator_sign_in_required など）ときは、もう一度ログインしてもらう。
 */
const SupportEnded: React.FC = () => {
  const { t } = useTranslation('layout');
  const titleId = useId();
  const heading = useRef<HTMLHeadingElement>(null);
  const { busy, error, signIn, run } = useSupportReturn();

  useEffect(() => {
    heading.current?.focus();
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-primary/50 p-4">
      <section aria-labelledby={titleId} className="flex w-full max-w-lg flex-col gap-4 rounded-lg bg-white p-6 shadow">
        <h1 id={titleId} ref={heading} tabIndex={-1} className="text-title font-bold text-neutral/300 outline-none">
          {t('support.ended-title')}
        </h1>
        <p className="text-body-2 text-neutral/300">{t('support.ended-lead')}</p>
        <ErrorNotice messages={error ? [error] : []} />
        {signIn ? (
          <SignInAgain />
        ) : (
          <div className="flex justify-end">
            <button type="button" className={primaryButton} onClick={() => run(false)} disabled={busy}>
              {busy ? t('support.returning') : t('support.return')}
            </button>
          </div>
        )}
      </section>
    </main>
  );
};

export default SupportEnded;
